/**
 * Creates a map with values that we want to keep.
 *
 * @param keysToKeep
 * @param getMethod A method that provides the value when we pass it the key, such as a store get prop method
 */
export function createKeepMap<PROPS>(
  keysToKeep: (keyof PROPS)[],
  getMethod: (key: keyof PROPS) => PROPS[keyof PROPS],
): Map<keyof PROPS, PROPS[keyof PROPS]> | null {
  if (!keysToKeep.length) return null;

  const keepMap: Map<keyof PROPS, PROPS[keyof PROPS]> = new Map();

  keysToKeep.forEach(k => {
    keepMap.set(k, getMethod(k));
  });

  return keepMap;
}
